import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DarkModeSwitcherComponent } from './dark-mode-switcher.component';


@NgModule({
    declarations: [DarkModeSwitcherComponent],
    imports: [
        CommonModule
    ],
    exports: [
        DarkModeSwitcherComponent
    ]
})
export class DarkModuleSwitcherModule { }
